const messages = {
  title: "Početna",
  welcomeMessage:
    'Dobrodošli u BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Početna",
  search: "Pretraži",
  sortBy: "Sortiraj po",
  seeMore: "Vidi više",
  bankstatement: {
    yourScore: "Vaš trenutni broj marketinških bodova:",
    lastUpdate: "Zadnje ažuriranje:",
    link: "Pregled stanja bodova",
  },
  shop: {
    bestSold: "Najprodavanije",
    seasonal: "Sezonski",
    affordable: "Pristupačno",
    forPoints: "za {points} bodova",
    reachedPoints: "Potrebni bodovi postignuti",
    cartRemainPoints: "Preostali bodovi",
    remainingPoints: "{points} preostalih bodova",
    noProducts: "Kriterijumi pretrage nisu dali rezultata",
    variant: "Varijante na izbor",
  },
  showAllProducts: "Idi u shop",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>uskoro će ponovo biti dostupan.</div>",
};

export default {
  messages,
};
